import { render, staticRenderFns } from "./SportGames.vue?vue&type=template&id=dd1bb426"
import script from "./SportGames.vue?vue&type=script&lang=js"
export * from "./SportGames.vue?vue&type=script&lang=js"
import style0 from "./SportGames.vue?vue&type=style&index=0&id=dd1bb426&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports